import React, { useMemo } from "react";
import { Col, Row, Typography } from "antd";
import ReactEchart from "../../../../../../molecules/ReactEchart";
import { formatString } from "../../../../../../../utils/formatString";
import { funnelColors } from "../../../../utili";

const { Text } = Typography;

const FunnelChart = React.memo((props: any) => {
  const { data } = props;

  const chartData = useMemo(() => {
    if (!Array.isArray(data)) return [];

    let finalData = [];
    // Step 1: Aggregate values by key (excluding _id)
    data.forEach((item) => {
      Object.entries(item).forEach(([key, value]: any) => {
        if (key !== "_id") {
          finalData.push({
            name: formatString(key),
            value: item[key].count,
            percentage: item[key].percentage ? item[key].percentage : 0,
          });
        }
      });
    });

    return finalData;
  }, [data]);

  // in option put two time series for
  // handeling label inside and at top of funnel
  const options: any = useMemo(
    () => ({
      tooltip: {
        show: true,
        backgroundColor: "#3E7A9E",
        borderColor: "transparent",
        textStyle: { color: "#fff", fontSize: 14, fontWeight: "bold" },
      },
      legend: { show: false },

      series: [
        {
          // name: "Bookings Funnel",
          type: "funnel",
          orient: "horizontal",
          left: "5%",
          right: "5%",
          width: "90%",
          minSize: "10%",
          maxSize: "100%",
          sort: "none",
          // gap: 1,
          label: {
            show: true,
            color: "#4682a9",
            position: "top",
            formatter: (params) => {
              const data = params.data as {
                name?: string;
                value?: number;
                percentage?: string;
              };
              return `{percentage|${data.percentage}}%`;
            },
            rich: {
              percentage: {
                fontSize: 16,
                fontWeight: "bold",
                color: "#4682a9",
                align: "center",
              },
            },
          },
          labelLine: {
            show: false,
          },
          itemStyle: {
            color: (params) => funnelColors[params.dataIndex],
          },
          emphasis: {
            label: {
              position: "inside",
            },
          },
          data: chartData?.map((item) => ({
            value: item.value,
            name: item.name,
            percentage: item.percentage,
          })),
        },
        {
          type: "funnel",
          orient: "horizontal",
          left: "5%",
          right: "5%",
          width: "90%",
          minSize: "15%",
          maxSize: "100%",
          sort: "none",
          label: {
            show: false,
            color: "#f8f8f8",
            position: "inside",
            formatter: (params) => {
              const data = params.data as {
                name?: string;
                value?: number;
                percentage?: string;
              };
              return `{title|${data.name}}\n{value|${data.value}}\n{percentage|${data.percentage}}%`;
            },
            rich: {
              title: {
                fontSize: 10,
                fontWeight: "normal",
                color: "#f8f8f8",
                align: "center",
              },
              value: {
                fontSize: 16,
                fontWeight: "bold",
                color: "#f8f8f8",
                align: "center",
              },
              percentage: {
                fontSize: 12,
                fontWeight: "bold",
                color: "#f8f8f8",
                align: "center",
              },
            },
          },
          itemStyle: {
            color: (params) => funnelColors[params.dataIndex],
          },
          emphasis: {
            label: {
              position: "inside",
            },
          },
          data: chartData?.map((item) => ({
            value: item.value,
            name: item.name,
            percentage: item.percentage,
          })),
        },
      ],
    }),
    [data]
  );

  return (
    <div style={{ textAlign: "center", width: "100%", marginTop: 15 }}>
      <Row gutter={[0, 0]} justify="space-around">
        {chartData?.map((item, index) => (
          <Col key={index}>
            <Text style={{ fontSize: "14px", fontWeight: "bold", color: "#666" }}>{item.name}</Text>
            <br />
            <Text style={{ fontSize: "20px", fontWeight: "bold", color: "#123A55" }}>{item.value}</Text>
          </Col>
        ))}
      </Row>

      <ReactEchart key={JSON.stringify(data)} options={options} style={{ width: "100%", height: "400px" }} />
    </div>
  );
});

export default FunnelChart;
